import request from '../config/axiosConfig';
import { GET_LIST_VIDEOS, GET_VIDEO_INFO, CREATE_VIDEO, UPDATE_VIDEO, DELETE_VIDEO } from '../constants/videoApiEndPoint';

export const getVideos = async (params) => {
  return (
    await request({
      url: GET_LIST_VIDEOS,
      method: 'GET',
      params,
    })
  )?.data;
};

export const getVideoInfo = async (id) => {
  return (
    await request({
      url: GET_VIDEO_INFO,
      method: 'GET',
      params: { id },
    })
  )?.data;
};

export const createVideo = async (data) => {
  return (
    await request({
      url: CREATE_VIDEO,
      method: 'POST',
      data,
    })
  )?.data;
};

export const updateVideo = async (id, data) => {
  return (
    await request({
      url: UPDATE_VIDEO,
      method: 'POST',
      params: { id },
      data,
    })
  )?.data;
};

export const deleteVideo = async (id) => {
  return (
    await request({
      url: DELETE_VIDEO,
      method: 'DELETE',
      params: { id },
    })
  )?.data;
};
